import React from "react";
import { TableCellProps, Td as ChakraTd } from "@chakra-ui/react";
import { Consumer } from "../utils";

interface ITdInnerProps extends TableCellProps {
  narrowHeaders: Record<number, any>;
  headerTitle?: string;
}

const TdInner = (props: ITdInnerProps) => {
  const { narrowHeaders, headerTitle, ...rest } = props;
  const classes = `${props.className || ""} pivoted`;

  return (
    <ChakraTd data-testid="td" {...rest} className={classes}>
      <div data-testid="td-before" className="tdBefore">
        {headerTitle}
      </div>
      {props.children ?? <div>&nbsp;</div>}
    </ChakraTd>
  );
};

export interface ITdProps extends Omit<ITdInnerProps, "narrowHeaders"> { }

export const Td = (props: ITdProps) => (
  <Consumer>
    {(headers) => <TdInner {...props} narrowHeaders={headers} />}
  </Consumer>
);
